import clsx from 'clsx'

import { useModalContext } from './ModalContext'

import styles from './ModalDescription.module.scss'

type ModalDescriptionProps = {
  visuallyHidden?: boolean
  children: React.ReactNode
}

export const ModalDescription = ({
  visuallyHidden = false,
  children
}: ModalDescriptionProps) => {
  const context = useModalContext()

  if (!context) {
    throw new Error('ModalDescription must be used inside a <Modal> component.')
  }

  return (
    <p
      id={`${context.id}-description`}
      className={clsx(styles.description, { 'visually-hidden': visuallyHidden })}
    >
      {children}
    </p>
  )
}

export default ModalDescription
